import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

/** DEMO-ONLY MVP 8.2.1 — affiliate account option for sales-rep login / header picker. */
export interface PresidioSalesRepAccountOption {
  customerNo: string;
  companyName: string;
}

/**
 * DEMO-ONLY — affiliate account picker (login gate + header Sales Accounts).
 */
@Component({
  selector: 'ish-sales-rep-account-select-modal',
  templateUrl: './sales-rep-account-select-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, TranslatePipe, FormsModule],
})
export class SalesRepAccountSelectModalComponent {
  private readonly activeModal = inject(NgbActiveModal);

  @Input() accounts: PresidioSalesRepAccountOption[] = [];
  /** When true, show close control (header switch). Login gate keeps this false. */
  @Input() dismissible = false;
  @Input() titleKey = 'login.sales_rep.account_title';
  @Input() hintKey = 'login.sales_rep.account_hint';
  @Input() continueKey = 'login.sales_rep.account_continue';
  @Input()
  set currentCustomerNo(value: string | null | undefined) {
    const next = (value || '').trim();
    if (next && !this.selectedCustomerNo) {
      this.selectedCustomerNo = next;
    }
  }

  selectedCustomerNo = '';

  confirm(): void {
    if (!this.selectedCustomerNo) {
      return;
    }
    this.activeModal.close(this.selectedCustomerNo);
  }

  hide(): void {
    this.activeModal.dismiss();
  }
}
